

module.exports = __webpack_require__.stylable.create(
    "focusable1057284438",
    {"classes":{"root":"focusable1057284438__root","focus-box":"focusable1057284438__focus-box","focus-box-error":"focusable1057284438__focus-box-error"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/wix-ui-core/dist/src/hocs/Focusable/Focusable.st.css */ 222,
    null
);
